import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { doc, setDoc } from 'firebase/firestore';
import { auth, db } from '../firebase';

const SelectGrade = () => {
  const [selectedGrade, setSelectedGrade] = useState('1');
  const navigate = useNavigate();

  const handleGradeSelection = async () => {
    if (auth.currentUser) {
      // Save selected grade to user profile
      const userRef = doc(db, 'users', auth.currentUser.uid);
      await setDoc(userRef, { grade: selectedGrade }, { merge: true });
      
      // Navigate to quiz page
      navigate('/quiz');
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="max-w-md w-full p-6 bg-white rounded-lg shadow-lg">
        <h1 className="text-2xl font-bold text-center text-gray-800 mb-6">
          Select Your Grade
        </h1>
        
        <div className="mb-6">
          <label className="block text-gray-700 text-sm font-bold mb-2">
            Which grade are you in?
          </label>
          <select
            value={selectedGrade}
            onChange={(e) => setSelectedGrade(e.target.value)}
            className="w-full p-2 border rounded"
          >
            <option value="1">Grade 1</option>
            <option value="2">Grade 2</option>
            <option value="3">Grade 3</option>
            <option value="4">Grade 4</option>
            <option value="5">Grade 5</option>
            <option value="6">Grade 6</option>
          </select>
        </div>
        
        <button
          onClick={handleGradeSelection}
          className="w-full bg-blue-500 text-white py-2 rounded hover:bg-blue-600"
        >
          Continue
        </button>
      </div>
    </div>
  );
};

export default SelectGrade; 